// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fM","advertDetailContacts__header":"c-n_fN"};